/**
 * Back to Top — scroll listener + smooth scroll
 * Replaces React BackToTop.tsx
 * Threshold: 300px (matches React ref: 400px; task spec: 300px)
 */
(function () {
  'use strict';

  var btn = document.getElementById('back-to-top');
  if (!btn) return;

  var THRESHOLD = 300;

  function onScroll() {
    if (window.scrollY > THRESHOLD) {
      btn.classList.add('is-visible');
    } else {
      btn.classList.remove('is-visible');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  // Run once on load in case page is already scrolled
  onScroll();
})();
